import { BlockAIThemeType } from 'types';

type ThemeTypeKey = 'DARK' | 'LIGHT';

export const THEME_TYPE: { [key in ThemeTypeKey]: BlockAIThemeType } = {
  DARK: 'dark',
  LIGHT: 'light',
};
